import { unwrapResult } from '@reduxjs/toolkit'
import { Col, message, Modal, notification, Pagination, Spin, Table, Tooltip } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { AGColumns } from './columns'
import { ThemeContext } from '../../theme/ThemeContext'
import {
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import SimpleAgGrid from '../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../models/common'
import { DateRangeType, getDateRange } from '../../compnents/form/DateSelect'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../transactionQuery/transactionQuerySlice'
import { getChainSalesStatisticsExport, getChainSalesStatisticsList } from './chainSalesStatisticsSlice'
import { Query } from './Query'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'

const ChainSalesStatistic = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '分店名称',
      field: 'tenantName',
      minWidth: 200,
      visible: true,
    },
    {
      headerName: '药品信息',
      field: 'drugName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '开票项目',
      field: 'billingCategory',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '销售数量',
      field: 'salesQuantity',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '销售单位',
      field: 'accountUnit',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '拆零销售数量',
      field: 'salesSplitQuantity',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '拆零单位',
      field: 'splitUnit',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '销售单价',
      field: 'retailPrice',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '拆零销售单价',
      field: 'retailSplitPrice',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '成本单价',
      field: 'unitPrice',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '拆零成本单价',
      field: 'unitSplitPrice',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '销售金额',
      field: 'salesAmount',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '利润',
      field: 'profit',
      minWidth: 100,
      visible: true,
    },
    // {
    //   headerName: '结算状态',
    //   field: 'payStatus',
    //   minWidth: 100,
    //   visible: true,
    // },
  ]?.map((item: any, index: number) => ({
    ...item,
    index: index + 1,
  }))

  const allData = listData
  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    isAccurate: false,
    isMerge: 0,
    timeHead: moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
    timeTail: moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
  })

  const [page, setPage] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'chainSalesStatistics',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'chainSalesStatistics',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const sameFileds = allData?.find((item: any) => item?.field == v?.field)
        const resetData = data?.map((v: any) => ({
          ...v,
          minWidth: sameFileds?.minWidth || v?.minWidth,
          width: sameFileds?.width || v?.width,
          headerName: sameFileds?.headerName || v?.headerName,
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    setAllColumnList(allData)
  }, [])

  useEffect(() => {
    if (params?.timeHead && params?.timeTail) {
      setPageLoading(true)
      getPage()
      getPageColumnList()
    }
  }, [params])

  const getPage = () => {
    dispatch(getChainSalesStatisticsList({ ...params }))
      .then(unwrapResult)
      .then((v: any) => {
        setPage({
          items: v?.records,
          size: v?.size,
          total: v?.total,
          current: v?.current,
        })
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  const exportExcel = () => {
    setExportLoading(true)
    dispatch(
      getChainSalesStatisticsExport({
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '连锁销售统计.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  return (
    <>  <TabBar style={{ margin: '10px 20px' }}>
      <TabPane key='0' tab='连锁销售统计'>
        <Col
          style={{
            backgroundColor: theme.pn,
            borderRadius: 10,
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 30px)',
            marginTop: '10px',
            overflow: 'hidden',
            padding: '10px 15px 20px 15px',
          }}
        >
          <Query
            exportLoading={exportLoading}
            loading={pageLoading}
            onValueChange={(v: any) => {
              const paramData = {
                ...params,
                ...v,
                isMerge: v?.isMerge || 0,
                current: 1,
                timeHead: v?.timeHead
                  ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
                  : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
                timeTail: v?.timeTail
                  ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
                  : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
              }
              setParams({
                ...paramData,
              })
            }}
            filterColumn={allColumnList} //筛选列
            filterSelectList={filterSelectList}
            // 筛选列变化时的数据
            submitPageList={(v: any) => {
              setPageLoading(true)
              submitPageList(v)
              setAllColumnList(v)
            }}
            export={(() => {
              exportExcel()
            })}
          />
          <div
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            <SimpleAgGrid
              page={page}
              column={(AGColumns(
                page?.size * (page?.current - 1),
                allColumnList,
                params?.isMerge,
              ))?.filter((item: any) => filterSelectList?.includes(item.field))}
              isLoading={pageLoading}
              pagination={true}
              pageKey={'chainSalesStatistics'}
              rowSelection="multiple"
              // 配置底部行样式
              getRowStyle={(params: any) => {
                if (params.node.rowPinned) {
                  return {
                    fontWeight: 'normal',
                    backgroundColor: '#D9F2FF',
                  };
                }
                return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
              }}
              onChangePage={(current, size) => {
                setParams({
                  ...params,
                  current,
                  size,
                })
                setPage({
                  ...page,
                  current,
                  size,
                })
              }}
              onColumnResized={(v) => {
                return
              }}
              onColumnMoved={(v) => {
                const sortList = getSortColumnList(allColumnList, v);
                submitPageList(sortList)
                setAllColumnList(sortList)
              }}
            />
          </div>
        </Col>
      </TabPane>
    </TabBar>
    </>

  )
}

export const ChainSalesStatistics = forwardRef(ChainSalesStatistic)
